import React from 'react';
import PropTypes from 'prop-types';

interface ForProps<T> {
  render: (item: T, index: number) => React.ReactNode;
  of: T[];
}

export const For = <T,>({ render, of }: ForProps<T>): JSX.Element => (
  <>
    {of.map((item: T, index: number) => {
      const child = render(item, index);
      if (React.isValidElement(child) && child.key == null) {
        const keyed = item as { id?: React.Key; key?: React.Key } | null;
        return React.cloneElement(child, {
          key: keyed?.id ?? keyed?.key ?? index,
        });
      }
      return child;
    })}
  </>
);

For.propTypes = {
  of: PropTypes.array.isRequired,
  render: PropTypes.func.isRequired,
};
